import React from 'react';

import { EmptyState } from '../EmptyState';

export function ErrorBoundaryFallback({ resetError }) {
    return (
        <EmptyState
            icon="⚠️"
            title="خطا در نمایش صفحه"
            message="مشکل غیرمنتظرهای رخ داده است. لطفاً دوباره تلاش کنید."
            action="🔄"
            actionText="تلاش مجدد"
            onAction={resetError}
        />
    );
}

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
        };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        const scope = this.props.context && this.props.context.scope
            ? `:${this.props.context.scope}`
            : '';
        console.error(`[withErrorBoundary${scope}]`, error, errorInfo);
    }

    resetError = () => {
        this.setState({ hasError: false });
    };

    render() {
        if (this.state.hasError) {
            if (typeof this.props.fallbackComponent === 'function') {
                return this.props.fallbackComponent({ resetError: this.resetError });
            }
            return (
                this.props.fallbackComponent ?? (
                    <ErrorBoundaryFallback resetError={this.resetError} />
                )
            );
        }

        return this.props.children;
    }
}

export const withErrorBoundary = (context = {}, fallbackComponent) => (Component) => (props) => {
    return (
        <ErrorBoundary context={context} fallbackComponent={fallbackComponent}>
            <Component {...props} />
        </ErrorBoundary>
    );
};

export default withErrorBoundary;